<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (eventModel) {
    <div class="detail-page-action-bar">
        @if (eventPermissions.canSave || eventPermissions.canSaveDataBreach) {
            <button class="btn btn-cerrix" (click)="save()">
                <i class="fas fa-save"></i>
                <span data-uiid="event-save" class="d-none d-lg-inline">{{ 'event.detail.saveEvent' | transloco }}</span>
            </button>
        }

        @if (eventModel.ID > 0) {
            <span class="date-edited">
                {{ 'event.detail.lastSave' | transloco }} {{ eventModel.LastSaveDate | dateTimeFormat }}
            </span>
        }

        <div class="workflow-area">
            <span class="workflow-description">
                {{ 'event.detail.workflowStatusLabel' | transloco }}
                <b>{{
                    eventModel.Workflow && eventModel.Workflow.StatusDescription
                        ? eventModel.Workflow.StatusDescription
                        : ('event.detail.workflowNewEvent' | transloco)
                }}</b>
                <i
                    class="far fa-question-circle mx-2"
                    [matTooltip]="
                        eventModel.Workflow && eventModel.Workflow.StatusDescription
                            ? eventModel.Workflow.StatusDescription
                            : ('event.detail.workflowCurrentlyStatus' | transloco)
                    "
                ></i>
            </span>
            @if (nextStatus) {
                <button
                    type="button"
                    (click)="newCommentDialog(true)"
                    class="btn btn-success"
                    id="positive"
                    title="{{ titlePos }}"
                >
                    {{ nextStatus }}
                </button>
            }
            @if (backStatus) {
                <button
                    (click)="newCommentDialog(false)"
                    class="btn btn-danger"
                    id="negative"
                    title="{{ titleNeg }}"
                >
                    {{ backStatus }}
                </button>
            }
        </div>
    </div>

    <div
        class="event-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div class="event-screens" [attr.name]="'event.detail.menuEvent' | transloco" menuItemId="Event" menuicon="fas fa-bolt" menusystemsubmenu>
            <div [attr.name]="'event.detail.menuDetails' | transloco" menuItemId="menuItemDetails" menuicon="fas fa-info-circle" menusystemitem>
                <event-detail-main
                    [eventModel]="eventModel"
                    [sdLight]="sdLight"
                    [sdHeavy]="sdHeavy"
                    [parentForm]="parentForm"
                    [permissions]="eventPermissions"
                    novalidate
                ></event-detail-main>
            </div>
            <div
                data-uiid="event-databreach"
                [attr.name]="'event.detail.menuDataBreach' | transloco"
                menuItemId="menuItemDataBreach"
                menuicon="fas fa-unlock-alt"
                menusystemitem
            >
                <breach-detail
                    #dataBreachTab
                    [eventForm]="parentForm"
                    [eventPermissions]="eventPermissions"
                >
                </breach-detail>
            </div>
            <div
                class="event-screens"
                [attr.name]="'event.detail.menuLinks' | transloco"
                menuItemId="Links"
                menuicon="fas fa-link"
                menusystemsubmenu
            >
                @if (eventModel.ID > 0) {
                    <div [attr.name]="'event.detail.menuMeasuresOfImprovement' | transloco" menuItemId="menuItemMeasuresOfImprovement" menuicon="fas fa-tasks" menusystemitem>
                        <linked-moi-overview
                            [moiType]="lerMoiType"
                            [parentGuid]="eventModel.Guid"
                            [canAdd]="eventPermissions.canAddMoi"
                            [canDelete]="eventPermissions.canDeleteMoi"
                            #eventMoisComponent
                        >
                        </linked-moi-overview>
                    </div>
                    <div [attr.name]="'event.detail.menuRisks' | transloco" menuItemId="menuItemRisks" menuicon="fas fa-exclamation-triangle" menusystemitem>
                        <event-risk
                            [disabled]="!eventPermissions.canLinkRisks"
                            [eventModel]="eventModel"
                            [parentForm]="parentForm"
                            (linkChanged)="checkDirty()"
                            #eventRiskComponent
                        >
                        </event-risk>
                    </div>
                    <div [attr.name]="'event.detail.menuControls' | transloco" menuItemId="menuItemControls" menuicon="fas fa-shield-alt" menusystemitem>
                        <event-control
                            [disabled]="!eventPermissions.canLinkControls"
                            [eventModel]="eventModel"
                            [parentForm]="parentForm"
                            (linkChanged)="checkDirty()"
                            #eventControlComponent
                        >
                        </event-control>
                    </div>
                }
                <div
                    [attr.name]="'event.detail.menuDocuments' | transloco"
                    menuItemId="menuItemDocuments"
                    menuicon="far fa-file"
                    menusystemitem
                >
                    <div>
                        @if (documents) {
                            <document-manager-old
                                [(Documents)]="eventModel.Documents"
                                (DocumentsChange)="checkDocumentsDirty()"
                                [permissions]="eventPermissions.documentPermissions"
                                [DocumentTypeTargets]="targetModule"
                            ></document-manager-old>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
                <div
                    [attr.name]="'event.detail.menuHyperlinks' | transloco"
                    [attr.menuItemID]="hyperlinksMenuItemId"
                    menuicon="fas fa-external-link-alt"
                    menusystemitem
                >
                    <div>
                        @if (eventModel.Hyperlinks) {
                            <hyperlink-manager
                                [(Hyperlinks)]="eventModel.Hyperlinks"
                                (HyperlinksChanged)="checkHyperlinksDirty($event)"
                                [TargetModule]="targetModule"
                            ></hyperlink-manager>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
            </div>
            @if (eventModel.ID > 0) {
                <div [attr.name]="'event.detail.menuHistory' | transloco" menuItemId="History" menuicon="fas fa-history" menusystemsubmenu>
                    <div [attr.name]="'event.detail.menuEventHistory' | transloco" menuItemId="menuItemEventHistory" menuicon="fas fa-bolt" menusystemitem>
                        <app-history-overview
                            [historyDataService]="_eventDS"
                            [Id]="eventModel.Guid"
                            [useOldHistory]="true"
                            [label]="'event.detail.historyLabelEvent' | transloco"
                            #eventHistoryOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                    <div [attr.name]="'event.detail.menuDataBreachHistory' | transloco" menuItemId="menuItemDataBreachHistory" menuicon="fas fa-unlock-alt" menusystemitem>
                        <app-history-overview
                            [historyDataService]="_breachDS"
                            [Id]="eventModel.DataBreachGuid"
                            [useOldHistory]="true"
                            #breachHistoryOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                </div>
                <div [attr.name]="'event.detail.menuOptions' | transloco" menuItemId="menuItemOptions" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="event"
                        [objectName]="eventModel ? eventModel.Name : 'event'"
                        [allowDelete]="eventPermissions.isAdmin"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
